import { SclaApplication } from 'features/scla/types';
import { makePostRequest } from 'lib/axios';

const ackSclaPrefill = async (
  id: string,
  section: string,
): Promise<SclaApplication> => {
  const response = await makePostRequest(`/scla/application/${id}/prefill-seen`, { section });
  return response.data.payload;
};

export default ackSclaPrefill;
